import React, { useEffect } from 'react';
import {
    Platform,
    StyleSheet,
    Text,
    TouchableOpacity,
    Image,
    View,
} from 'react-native';

import { GiftedChat, Actions, Bubble, Send } from 'react-native-gifted-chat';
import { serverURL, serverWSURL } from '../constants/serverURL';
import { storeCache, getCache } from '../utils/cacheStore'
import { parseJwt } from '../utils/parseToken';
import ChatWindowHolder from './ChatWindowHolder';
import { ReactNotifications, Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { closeBanner } from '../utils/admob';



function truncate(str, n) {
    return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
};



export default class ChatWindow extends React.Component {
    constructor(props) {
        super(props);
        getCache("token").then((value: string) => {
            var user = parseJwt(value)
            this.setState({
                username: user.username
            })
        })


        getCache("webSocketToken").then((value: string) => {
            this.setState({
                wsToken: value
            })
            console.log("WSTOKEN VAL: ", value);
            this.setupWebsocket()
        })

    }

    setupWebsocket(){
        console.log("Setting up websocket: ", this.props.route.params.gameID);
        var chatLink = serverWSURL + "/online/chat/" + this.props.route.params.gameID + "/?token=" + this.state.wsToken
        console.log("GameID: ", this.props.route.params.gameID);
        console.log("WSTOKEN: ", this.state.wsToken);

        var ws = new WebSocket(chatLink);
        var pingInterval;
        ws.onopen = () => {
            // connection opened
            console.log("Successfully opened chat connection")
            //ws.send('connected');  // send a message
            pingInterval = setInterval(() => ws.send(""), 1000);
        };


        this.state = {
            messages: [],
            loadEarlier: true,
            typingText: null,
            isLoadingEarlier: false,
            ws: ws,
            unread: 0,
        };

        this._isMounted = false;
        this.onSend = this.onSend.bind(this);
        this.onReceive = this.onReceive.bind(this);
        this.resetChatNotification = this.resetChatNotification.bind(this);
        this._isAlright = null;

        var compon = this;
        var errorFunc;
        errorFunc = (e) => {
            console.log("Websocket error: ", e)
            clearInterval(pingInterval);
            var ws = new WebSocket(chatLink);
            ws.onopen = () => {
                // connection opened
                console.log("Successfully re-opened chat connection on error")
                //ws.send('connected');  // send a message
                pingInterval = setInterval(() => ws.send(""), 1000)
            };

            ws.onmessage = (e) => {
                console.log("Received from chatter: ", e.data)

                e.data.text().then((value: string) => {
                    console.log("Received man: ", value)
                    var msg = JSON.parse(value);
                    this.onReceive(msg);
                })
            };

            ws.onerror = errorFunc;

            setTimeout(function () {
                compon.setState({
                    ws: ws
                })
            }, 1000);


        } 

        var closeFunc;
        closeFunc = (e) => {
            console.log('Socket is closed. Reconnect will be attempted in 1 second.', e.reason);
            clearInterval(pingInterval);
            if (!this._isMounted){
                console.log("Returning because websocket is unmounted")
                return
            }
            var ws = new WebSocket(chatLink);
            ws.onopen = () => {
                // connection opened
                console.log("Successfully re-opened chat connection on close")
                //ws.send('connected');  // send a message
                pingInterval = setInterval(() => ws.send(""), 1000)
            };

            ws.onmessage = (e) => {
                console.log("Received from chatter: ", e.data)

                e.data.text().then((value: string) => {
                    console.log("Received man: ", value)
                    var msg = JSON.parse(value);
                    this.onReceive(msg);
                })
            };

            ws.onerror = errorFunc;

            setTimeout(function () {
                console.log(this)
                compon.setState({
                    ws: ws
                })
            }, 1000);
        };
        ws.onerror = errorFunc;

        ws.onmessage = (e) => {
            console.log("Received from chatter: ", e.data)

            e.data.text().then((value: string) => {
                console.log("Received man: ", value)
                var msg = JSON.parse(value);
                this.onReceive(msg);
            })
        };

        ws.onclose = closeFunc;
    }

    componentWillMount() {

        this._isMounted = true;
        this.setState(() => {
            return {
                messages: [],
            };
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.state && this.state.ws) {
            try {
                this.state.ws.onclose = null;
                this.state.ws.onerror = null;
                this.state.ws.onmessage = null;
                this.state.ws.close();
            } catch (e) {
                console.log("Error closing chat ws: ", e);
            }
        }
    }

    onSend(messages = []) {
        for (var i = 0; i < messages.length; i++) {
            var message = {
                messageData: messages[i].text,
                voiceData: "",
            }
            this.state.ws.send(JSON.stringify(message));
        }
        this.setState((previousState) => {
            return {
                messages: GiftedChat.append(previousState.messages, messages),
            };
        });

    }

    resetChatNotification() {
        this.setState({
            unread: 0,
        });
    }


    onReceive(msg) {
        if (!this._isMounted) {
            return
        }

        if (msg.user === this.state.username) {
            return
        }

        if (msg.messageData == "" && msg.voiceData == "") {
            return
        }

        if (msg.messageData == "" && msg.voiceData != "") {
            msg.messageData = "<Voice notes not supported in this chat>"
        }

        var notifData = truncate(msg.messageData, 140);

        Store.addNotification({
            title: msg.user,
            message: notifData,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 2500,
                onScreen: false
            }
        });

        this.setState((previousState) => {
            return {
                messages: GiftedChat.append(previousState.messages, {
                    _id: Math.round(Math.random() * 1000000),
                    text: msg.messageData,
                    createdAt: new Date(),
                    user: {
                        _id: msg.id,
                        name: msg.user,
                        // avatar: 'https://facebook.github.io/react/img/logo_og.png',
                    },
                }),
            };
        });
    }


    renderBubble(props) {
        return (
            <Bubble
                {...props}
                wrapperStyle={{
                    left: {
                        backgroundColor: '#f0f0f0',
                    },
                    right: {
                        backgroundColor: '#268529',
                    }
                }}
            />
        );
    }

    componentDidMount(): void {
        console.log("Chat window mounted");
        // console.log(this.props.navigation)
        this.props.navigation.addListener("tabPress", async (e) => {
            // add your business logic here
            console.log("Chat window tab pressed")
            closeBanner();
        })
    }

    renderFooter(props) {
        if (this.state.typingText) {
            return (
                <View style={styles.footerContainer}>
                    <Text style={styles.footerText}>
                        {this.state.typingText}
                    </Text>
                </View>
            );
        }
        return null;
    }



    componentWillUnMount

    routerWillLeave(nextLocation) {
        return false;
    }

    render() {

        return (
            <>
                <GiftedChat
                    messages={this.state.messages}
                    onSend={this.onSend}
                    renderUsernameOnMessage={true}
                    isLoadingEarlier={this.state.isLoadingEarlier}
                    renderBubble={this.renderBubble}
                    user={{
                        _id: 1, // sent messages should have same user._id
                    }}
                />


            </>
        );
    }
}

